<template>
  <div>
    &copy; Copyright Doneth {{year}}
  </div>
</template>

<script>
export default {

  name: 'FooterInfo',

  data () {
    return {
      year: (new Date()).getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
  div {
    font-size: 11pt;
    margin: 40px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterInfo.vue